import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import {
  HotelRescheduleDetailAddOnsFormType,
  HotelRescheduleDetailHotelFormType,
  HotelRescheduleFormType,
} from '../form-type';

export function calculateRescheduleHotelAddOns(
  addons: HotelRescheduleDetailAddOnsFormType[],
) {
  const subtotal = addons
    .filter((hsao) => hsao.isSelected)
    .reduce((prev, hsao) => {
      return prev + (hsao.price || 0);
    }, 0);

  return subtotal;
}

export function calculateRescheduleHotel(
  hotel: HotelRescheduleDetailHotelFormType[],
  isByPax = false,
) {
  const subtotalHotel = hotel.reduce((prev, hsh) => {
    const price = hsh.price || 0;
    const pax = hsh.pax || 0;
    const night = hsh.night || 0;
    const room = hsh.room || 0;

    if (isByPax) {
      const total = price * pax;
      return prev + total;
    } else {
      const total = night * room * price;
      return prev + total;
    }
  }, 0);

  return subtotalHotel;
}

export default function useRecalculate() {
  const { control, setValue } = useFormContext<HotelRescheduleFormType>();
  const [hotelSales] = useWatch({
    control,
    name: ['hotelSales'],
  });

  const data = React.useMemo(() => {
    const total = hotelSales
      .filter((hs) => hs.isSelected)
      .reduce((prev, hs) => {
        const subtotalHotel = calculateRescheduleHotel(
          hs.hotelSaleHotels,
          hs.isByPax,
        );
        const subtotalAddOns = calculateRescheduleHotelAddOns(
          hs.hotelSaleAddOns,
        );
        return prev + subtotalAddOns + subtotalHotel;
      }, 0);
    setValue('total', total);
    return total;
  }, [hotelSales, setValue]);

  return data;
}
